import { Middleware, isRejectedWithValue, isRejected } from '@reduxjs/toolkit';
import { showToast } from '../../utils/toast';

// Error action type pattern for saga failures
const ERROR_ACTION_PATTERN = /Failure$/;

// Global error middleware to catch and display errors
export const errorMiddleware: Middleware = () => (next) => (action: any) => {
  // Handle Redux Toolkit rejected actions
  if (isRejectedWithValue(action)) {
    const errorMessage = action.payload?.message || action.payload || 'An error occurred';
    console.error('API Error:', errorMessage);
    showToast.error(errorMessage);
  }

  // Handle rejected thunks
  if (isRejected(action)) {
    const errorMessage = action.error?.message || 'An unexpected error occurred';
    console.error('Action Rejected:', errorMessage);
    // Don't show toast for cancelled actions
    if (action.error?.name !== 'AbortError') {
      showToast.error(errorMessage);
    }
  }

  // Handle custom failure actions from sagas (e.g., fetchSolutionFailure)
  if (typeof action.type === 'string' && ERROR_ACTION_PATTERN.test(action.type)) {
    const errorMessage = action.payload || 'An error occurred';
    console.error('Saga Error:', action.type, errorMessage);
    showToast.error(errorMessage);
  }

  return next(action);
};

export default errorMiddleware;
